<template>
  <v-app-bar
    class="members-header"
    app
    elevation="0"
    :background-color="'white'"
    :height="72"
  >
    <button @click="navigateToMedistream">
      <v-toolbar-title>
        <img
          src="../assets/logo-medistream.svg"
          class="logo-medistream-members"
          alt="medistream-logo"
        />
      </v-toolbar-title>
    </button>

    <div class="logout-button ml-auto">
      <v-btn outlined elevation="0" @click="logout">
        로그아웃
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { logout } from '@/services/apis';

export default {
  name: 'members-header',
  data() {
    return {
      logout,
    };
  },

  computed: {
    ...mapState(['$user']),
    ...mapGetters(['isAdmin']),
  },
  methods: {
    navigateToMedistream() {
      const url =
        process.env.NODE_ENV === 'production'
          ? 'https://www.medistream.co.kr'
          : process.env.NODE_ENV === 'staging'
          ? 'https://stg.medistream.co.kr'
          : 'https://dev.medistream.co.kr';
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-medistream-members {
  width: 10rem;
}

.v-app-bar {
  &.theme--light.v-toolbar.v-sheet {
    background-color: white;
    border-right: none;
    border-left: none;
    border-bottom: 1px solid #dfe0eb;
  }
  ::v-deep .v-toolbar__content {
    padding: 0;
    max-width: 62.5rem;
    margin: 0 auto;
  }
  ::v-deep .v-toolbar__extension {
    border-top: 1px solid #dfe0eb;
  }
  ::v-deep .theme--light.v-btn.v-btn--has-bg {
    background-color: white;
  }
}

a {
  text-decoration: none;
}

.v-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  color: #94969d !important;
  font-size: 0.8125rem !important;

  .v-icon {
    margin-right: 0.625rem;
  }
}

hr.v-divider {
  min-height: 2.5rem;
  max-height: 2.5rem;
  align-self: auto;
  margin-right: 0.5rem;
}

.members-header {
  padding: 0 11.5rem;
}
.v-btn.members-header__nav-buttons--to-reports {
  &.v-btn--active::before {
    opacity: 0;
    background-color: #fff;
  }

  ::v-deep .v-btn__content {
    color: #4e5173;
  }
}
::v-deep .header-button-active .v-btn__content {
  color: #000 !important;
}

.go-home {
  display: flex;
  align-items: center;
  color: rgb(44, 65, 255);
  font-weight: bold;
}

.logout-button {
  padding-left: 2rem;
}
</style>
